import { updateListing } from '../../../app-main/actions/listing';
import { toggleBanner } from '../../../app-main/actions/banner';
import { get } from 'lodash';
import update from 'immutability-helper';

const onSubmitDiscountRateForm = (values, dispatch, props) => {
  const accessToken = get(props, 'accessToken', '');
  const listingId = get(props, 'listing._id', '');
  const value = parseInt(get(values, 'day_rate_discount.value'), 10);

  const objState = value ? 'ACTIVATED' : 'DEACTIVATED';
  const payload = update(values, {
    day_rate_discount: {
      value: { $set: value || 0 },
      obj_state: { $set: objState },
      apply_as: { $set: 'PERCENT_OFF' }
    }
  });

  dispatch(updateListing(listingId, accessToken, payload))
    .then(() => dispatch(toggleBanner('save')))
    .catch(() => dispatch(toggleBanner('error')));
};

export default onSubmitDiscountRateForm;
